import React from 'react';
import * as Icons from './icons';
import { LucideIcon } from 'lucide-react';

/**
 * Map icon names (strings) to Lucide React components
 * Used by CommandPalette and other components that store icon names as strings
 */
export const iconMap: Record<string, LucideIcon> = {
  // Navigation & Actions
  LayoutDashboard: Icons.LayoutDashboard,
  Users: Icons.Users,
  Trophy: Icons.Trophy,
  Building2: Icons.Building2,
  Settings: Icons.Settings,
  Wrench: Icons.Wrench,
  Info: Icons.Info,
  Plus: Icons.Plus,
  UserPlus: Icons.UserPlus,
  RefreshCw: Icons.RefreshCw,
  LogOut: Icons.LogOut,
  Key: Icons.Key,
  Link: Icons.Link,
  Menu: Icons.Menu,
  X: Icons.X,
  ChevronLeft: Icons.ChevronLeft,
  ChevronRight: Icons.ChevronRight,
  
  // Data & Analytics
  TrendingUp: Icons.TrendingUp,
  TrendingDown: Icons.TrendingDown,
  Calendar: Icons.Calendar,
  ClipboardList: Icons.ClipboardList,
  Target: Icons.Target,
  BarChart3: Icons.BarChart3,
  
  // Health & Wearables
  Watch: Icons.Watch,
  Heart: Icons.Heart,
  HeartPulse: Icons.HeartPulse,
  Moon: Icons.Moon,
  Flame: Icons.Flame,
  Dumbbell: Icons.Dumbbell,
  Activity: Icons.Activity,
  
  // People & Communication
  User: Icons.User,
  UserCheck: Icons.UserCheck,
  Bot: Icons.Bot,
  MessageSquare: Icons.MessageSquare,
  
  // Status & Alerts
  CheckCircle2: Icons.CheckCircle2,
  AlertTriangle: Icons.AlertTriangle,
  AlertCircle: Icons.AlertCircle,
  XCircle: Icons.XCircle,
  
  // Theme
  Sun: Icons.Sun,
  
  // Misc
  Smartphone: Icons.Smartphone,
  Ruler: Icons.Ruler,
  Search: Icons.Search,
  Lightbulb: Icons.Lightbulb,
  Sparkles: Icons.Sparkles,
  Brain: Icons.Brain,
  Compass: Icons.Compass,
};

/**
 * Get icon component from string name
 */
export const getIcon = (iconName: string): LucideIcon | null => {
  return iconMap[iconName] || null;
};

/**
 * Render icon from string name with props
 */
export const renderIcon = (iconName: string, className?: string): React.ReactNode => {
  const IconComponent = getIcon(iconName);
  if (!IconComponent) {
    return <span>{iconName}</span>;
  }
  return <IconComponent className={className} />;
};

